import React, { useState, useRef, useEffect } from "react";
import PropTypes from "prop-types";
import MetaTags from "react-meta-tags";
import {
  Row,
  Col,
  Alert,
  Card,
  CardBody,
  Container,
  FormFeedback,
  Input,
  Label,
  Form,
  Button,
} from "reactstrap";
import { withRouter, Link } from "react-router-dom";
import loginbg from "../../assets/images/loginbg.png";
import findagramLogo from "../../assets/images/logoFindagram.png";
import ApiClient from "../../FindagramAdmin/BaseUrl/ApiClient";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import * as Yup from "yup";
import { useFormik } from "formik";

const ForgetPasswordPage = (props) => {
  const [errorMsg, setErrorMsg] = useState(null);
  const [successMsg, setSuccessMsg] = useState(null);
  const [loading, setLoading] = useState(false);
  const isMounted = useRef(true);

  useEffect(() => {
    return () => {
      isMounted.current = false; // Cleanup on unmount
    };
  }, []);

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      email: "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email("Invalid Email")
        .required("Please Enter Your Email"),
    }),
    onSubmit: async (values) => {
      setLoading(true);

      ApiClient.post("/auth/admin/forgotPassword", values)
        .then((response) => {
          const message =
            response?.data?.responseMessage?.[0] ||
            "Password reset email sent successfully";
          toast.success(message);
          setTimeout(() => {
            props.history.push("/reset-password");
          }, 2000);
        })
        .catch((error) => {
          console.log("Full Error:", error);
          console.log(error.response?.data);

          (error?.response?.data?.responseMessage || ["Try again please"]).forEach(
            (msg) => {
              toast.error(msg);
            }
          );
        })
        .finally(() => {
          if (isMounted.current) {
            setLoading(false);
          }
        });
    },
  });

  return (
    <React.Fragment>
      <ToastContainer />
      <div className="auth-page-content custom-auth-page">
        <MetaTags>
          <title>Forget Password | Findagram</title>
        </MetaTags>

        <div className="header-navbar">
          <div className="logo-col">
            <Link to="/" className="logo-link">
              <img src={findagramLogo} alt="Findagram" height="60" />
            </Link>
          </div>
        </div>

        <div className="header-line border-bottom"></div>

        <div
          className="background-section"
          style={{
            backgroundImage: `url(${loginbg})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            minHeight: "calc(100vh - 100px)",
          }}
        >
          <Container className="form-container">
            <Row className="justify-content-center">
              <Col md={8} lg={6} xl={5} className="card-col">
                <Card className="login-card mt-4">
                  <CardBody className="card-body">
                    <h5 className="welcome-text text-center text-dark">
                      Forget Password
                    </h5>
                    <p className="subtitle-text text-left">
                      Please enter your email.
                    </p>

                    {errorMsg && <Alert color="danger">{errorMsg}</Alert>}
                    {successMsg && <Alert color="success">{successMsg}</Alert>}

                    <Form
                      onSubmit={(e) => {
                        e.preventDefault();
                        validation.handleSubmit();
                      }}
                      className="login-form"
                    >
                      <div className="form-group mb-3 text-start">
                        <Label htmlFor="email" className="form-label formemail">
                          Email
                        </Label>
                        <Input
                          name="email"
                          className="form-control form-controlinput"
                          placeholder="Enter email here"
                          type="email"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.email || ""}
                          invalid={
                            validation.touched.email && validation.errors.email
                          }
                        />
                        {validation.touched.email && validation.errors.email ? (
                          <FormFeedback type="invalid">
                            {validation.errors.email}
                          </FormFeedback>
                        ) : null}
                      </div>

                      <div className="form-group mb-3">
                        <Button
                          className="w-100 signin-btn"
                          type="submit"
                          disabled={loading}
                        >
                          {loading ? (
                            <>
                              <span
                                className="spinner-border spinner-border-sm me-2"
                                role="status"
                                aria-hidden="true"
                              ></span>
                              Sending...
                            </>
                          ) : (
                            "Send"
                          )}
                        </Button>
                      </div>

                      <div className="text-center signup-section">
                        <p className="mb-0 signup-text">
                          Wait, I remember my password...{" "}
                          <Link to="/login" className="signup-link">
                            Click here
                          </Link>
                        </p>
                      </div>
                    </Form>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    </React.Fragment>
  );
};

ForgetPasswordPage.propTypes = {
  history: PropTypes.object,
};

export default withRouter(ForgetPasswordPage);
